import React from 'react'

import { useTranslation } from 'react-i18next'
import { FieldProps } from '../../../../../../../@types/types'
import { BasicInfoScreenValidationResult } from '../../../../../../../@types/validation-types'
import { TextInput } from '../../../../../../common/inputs/textInput/TextInput'
import LabelWithTooltip from '../common/LabelWithTooltip'
import LivingSpacePopoverContent from './LivingSpacePopoverContent'
import './LivingSpaceField.css'

export interface LivingSpaceFieldProps extends FieldProps<BasicInfoScreenValidationResult> {
  showToolTipInLabel?: boolean
}

const LivingSpaceField: React.FC<LivingSpaceFieldProps> = ({
  insertionData,
  validationMessages,
  screenName,
  onChange,
  showToolTipInLabel,
}) => {
  const { t } = useTranslation()

  const labelKey = 'wizard.screen.basicInfo.livingSpace.label'

  const labelWithTooltip = (
    <LabelWithTooltip
      inputId='living-space'
      labelText={t(labelKey, 'Living space')}
      tooltipContent={<LivingSpacePopoverContent />}
      showMandatory={true}
    />
  )

  const labelWithoutTooltip = <span>{t(labelKey, 'Living space')}</span>

  return (
    <div>
      {showToolTipInLabel && labelWithTooltip}
      <TextInput
        id='living-space'
        propertyName='livingSpace'
        placeholder=''
        label={showToolTipInLabel ? '' : labelWithoutTooltip}
        value={insertionData.livingSpace}
        maxLength={12}
        type={'number'}
        affixRight='unit'
        unitRight='sqm'
        errors={validationMessages?.livingSpace ?? []}
        doOnFieldChange={(property, value) => onChange({ screen: screenName, property }, value)}
        hideMandatorySign={showToolTipInLabel}
        dataHeyimmoContext='details_living_space'
      />
    </div>
  )
}

export default LivingSpaceField
